/* cg-r57.js (R57, Oct 23 2026). One source of truth for restaurant vs catering.
   Bug: a Taco Bar cart reached checkout as "Order Type: Catering Pickup" + "Catering Order: No" + ASAP.
   Cart attributes are sticky, so leftovers from an earlier restaurant or catering visit (Pickup, Channel,
   Catering Order) leaked into the next order. Shipy hides delivery when Order Type says pickup, so the
   guest could not pick delivery at checkout, and the kitchen would have got a catering order as ASAP.
   Fix: the cart CONTENTS decide the channel, never the old attributes.
   1. Every attribute write (outermost fetch wrapper) is shaped to match the cart: catering carts always carry
      Catering Order Yes, Channel catering and a "Catering ..." Order Type; restaurant carts never do.
   2. On every page load and after cart changes, the saved attributes are checked against the items and fixed.
      An empty cart starts clean.
   3. Catering carts always check out through /cart, where the catering panel enforces date, time,
      4-hour lead, zip and the $150 delivery minimum (guard is in snippets/cg-r57-guard, rendered before the
      restaurant checkout handlers). Thanksgiving carts keep their own Nov 26 flow.
   Loaded last (after cg-r55.js) so its fetch wrapper sees writes first. */
(function () {
  'use strict';
  if (window.__cgR57) return; window.__cgR57 = true;
  var R = window.CG_R57 = window.CG_R57 || {};
  var KEYS = ['Order Type', 'Channel', 'Catering Order', 'Order Timing', 'Requested Time', 'Pickup Time ISO', 'Pickup Time',
    'Scheduled Date', 'Scheduled Time', 'Headcount', 'Delivery Zip', 'Delivery Address'];
  var cater = null, cart = null, busy = false;
  try { cater = JSON.parse(sessionStorage.getItem('cg_r57_cater') || 'null'); } catch (e) {}

  var inner = window.fetch;
  function loadCater() {
    if (cater) return Promise.resolve(cater);
    var ids = {};
    function page(n) {
      return inner('/collections/catering/products.json?limit=250&page=' + n).then(function (r) { return r.json(); }).then(function (j) {
        (j.products || []).forEach(function (p) { ids[p.id] = 1; });
        if ((j.products || []).length === 250 && n < 4) return page(n + 1);
      });
    }
    return page(1).then(function () { cater = ids; try { sessionStorage.setItem('cg_r57_cater', JSON.stringify(ids)); } catch (e) {} return ids; },
      function () { cater = cater || {}; return cater; });
  }
  /* the theme marks catering items in the cart server side (tags), so a failed products.json never
     turns a catering cart into a restaurant one */
  function merged() { var m = {}, k; for (k in (cater || {})) m[k] = 1; (R.cartCat || []).forEach(function (id) { m[id] = 1; }); return m; }
  function known() { return !!(cater && Object.keys(cater).length); }
  function isTip(it) { return /^tip$/i.test(it.product_title || '') || /tip/i.test(it.product_type || ''); }
  function isCat(it) { return !!merged()[it.product_id] || /cater/i.test(it.product_type || ''); }
  function isTG(it) { return /thanksgiving/i.test((it.handle || '') + ' ' + (it.product_type || '')); }
  function kind(c) {
    var items = ((c && c.items) || []).filter(function (i) { return !isTip(i); });
    if (!items.length) return 'empty';
    return items.some(isCat) ? 'catering' : 'restaurant';
  }
  R.isCat = isCat;
  function mode(t) { t = String(t || ''); return /pickup/i.test(t) ? 'Pickup' : /deliver/i.test(t) ? 'Delivery' : ''; }

  /* the labels a cart of this kind must carry, given what is being written (a) and what is saved (cur) */
  function shape(k, a, cur) {
    var out = {}, has = function (key) { return key in a; }, v = function (key) { return has(key) ? a[key] : cur[key]; };
    var ot = v('Order Type'), m = mode(ot);
    /* switching between restaurant and catering: the other channel's time and order type are leftovers */
    var switching = k === 'catering' ? (cur['Channel'] === 'restaurant' || cur['Catering Order'] === 'No')
      : (cur['Channel'] === 'catering' || cur['Catering Order'] === 'Yes' || /^Catering/.test(String(cur['Order Type'] || '')));
    if (switching) {
      ['Order Timing', 'Requested Time', 'Pickup Time ISO', 'Scheduled Date', 'Scheduled Time'].forEach(function (key) { if (!has(key) && cur[key]) out[key] = ''; });
      if (k === 'restaurant' && !has('Order Type') && cur['Order Type']) { out['Order Type'] = ''; ot = ''; m = ''; }
    }
    if (k === 'catering') {
      if (v('Catering Order') !== 'Yes') out['Catering Order'] = 'Yes';
      if (v('Channel') !== 'catering') out['Channel'] = 'catering';
      /* a plain "Pickup"/"Delivery" on a catering cart is a restaurant leftover: drop it so the catering
         panel's own choice wins (cg-catering.js would otherwise read it and flip the order to pickup) */
      if (ot && !/^Catering (Pickup|Delivery)$/.test(ot)) out['Order Type'] = '';
      /* catering is never ASAP (4-hour lead): drop a restaurant ASAP time so the catering panel sets the real one */
      if (v('Order Timing') === 'ASAP' || v('Requested Time') === 'ASAP') { out['Order Timing'] = ''; out['Requested Time'] = ''; out['Pickup Time ISO'] = ''; }
    } else if (k === 'restaurant') {
      if (v('Catering Order') !== 'No') out['Catering Order'] = 'No';
      if (ot && /^catering/i.test(String(ot))) out['Order Type'] = m || 'Pickup';
      if (v('Channel') === 'catering') out['Channel'] = 'restaurant';
      if (v('Headcount')) out['Headcount'] = '';
      if (v('Delivery Address') && m !== 'Delivery') out['Delivery Address'] = '';
    }
    return out;
  }

  function view(c) {
    try {
      var k = kind(c); if (k === 'empty' || (k === 'restaurant' && !known())) return c;
      var fx = shape(k, {}, c.attributes || {});
      for (var key in fx) { if (fx[key] === '') delete c.attributes[key]; else c.attributes[key] = fx[key]; }
    } catch (e) {}
    return c;
  }

  /* 1. outermost wrapper: shape every attribute write */
  if (inner && !inner.__cgR57) {
    var w = function (url, opts) {
      var u = typeof url === 'string' ? url : (url && url.url) || '';
      try {
        if (/\/cart\/update(\.js)?(\?|$)/.test(u) && opts && typeof opts.body === 'string' && opts.body.charAt(0) === '{') {
          var b = JSON.parse(opts.body);
          if (b && b.attributes && !b.__r57skip) {
            var a = b.attributes, cur = (cart && cart.attributes) || {}, k = kind(cart);
            /* the catering script writes right after an add, before our cart copy knows about the new item */
            if (a['Catering Order'] === 'Yes' && k !== 'catering') k = 'catering';
            if (k === 'restaurant' && !known()) k = 'empty'; /* catering list not loaded: do not downgrade */
            if (k !== 'empty') { var fx = shape(k, a, cur); for (var key in fx) a[key] = fx[key]; }
            opts = Object.assign({}, opts, { body: JSON.stringify(b) });
          }
        }
      } catch (e) {}
      var p = inner.apply(this, [url, opts]);
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u)) p.then(function () { schedule(); }).catch(function () {});
      /* cart reads: page scripts only ever see labels that match the items (cg-catering.js hydrates its
         pickup/delivery mode from Order Type, the restaurant scripts key off Channel / Catering Order) */
      var meth = ((opts && opts.method) || (url && url.method) || 'GET').toUpperCase();
      if (meth === 'GET' && /\/cart\.js(\?|$)/.test(u)) p = p.then(function (r) {
        try { var j = r.json.bind(r); r.json = function () { return j().then(view); }; } catch (e) {}
        return r;
      });
      return p;
    };
    Object.keys(inner).forEach(function (k) { w[k] = inner[k]; }); w.__cgR57 = true; window.fetch = w;
  }

  /* 2. check the saved labels against the items */
  function save(attrs) {
    busy = true;
    return inner('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .then(function (r) { return r.json(); }).then(function (c) { cart = c; R.kind = kind(c); busy = false; return c; }, function () { busy = false; });
  }
  function check(first) {
    if (busy) return Promise.resolve(cart);
    /* read the cart raw (before the guard's read cleaner) so real leftovers get saved over */
    return loadCater().then(function () { return (R.rawFetch || inner)('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); }).then(function (c) {
        cart = c; var k = kind(c), a = c.attributes || {};
        R.kind = k; R.tg = (c.items || []).some(isTG);
        if (k === 'empty') {
          if (!first) return c;
          var clear = {}, dirty = false;
          KEYS.forEach(function (key) { if (a[key]) { clear[key] = ''; dirty = true; } });
          return dirty ? save(clear) : c;
        }
        if (k === 'restaurant' && !known()) return c;
        var fx = shape(k, {}, a);
        return Object.keys(fx).length ? save(fx) : c;
      }).catch(function () { return cart; });
  }
  var st = null;
  function schedule() { clearTimeout(st); st = setTimeout(function () { check(false); }, 700); }
  window.CGR57 = { check: check, kind: function () { return R.kind; } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { check(true); }); else check(true);
})();
